module.exports = __webpack_public_path__ + "static/img/190315-gene-microdelete.37ace42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/190315-gene-microdelete.jpg
// module id = KzF6
// module chunks = 0